import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../data.service';
import { MailRequest, MailRequestEx } from '../models/mailRequest';

@Component({
  selector: 'app-email-progress',
  templateUrl: './email-progress.component.html',
  styleUrls: ['./email-progress.component.scss']
})
export class EmailProgressComponent implements OnInit {

  private req : MailRequestEx;
  public errMessage: string;
  constructor(private data: DataService, private router: Router, private location: Location) { }

  ngOnInit(): void {
    this.req = this.data.MailReqEx;
    this.errMessage = "Sending mail, please wait...."
    this.SendMail();
  }

  SendMail(): void {
    console.log(this.req);
    this.data.request<string>("kiosk/mailrequestex",this.req,"POST").subscribe((e)=>{
      this.location.back();
    },(error)=>{
      this.errMessage = "Failed to send the mail, please try again";
      console.error(error);
      this.delay(3000).then((v) => {
        this.location.back();
      })
    })
  }

 delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }

}
